var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"content"}},[(_vm.selected_tab=='1')?_c('Blog'):_vm._e(),(_vm.selected_tab=='2')?_c('Works'):_vm._e(),(_vm.selected_tab=='6')?_c('ArtWorks'):_vm._e(),(_vm.selected_tab=='3')?_c('Experience'):_vm._e(),(_vm.selected_tab=='4')?_c('About'):_vm._e(),(_vm.selected_tab=='5')?_c('Contact'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }